var chatItemStyles = {
    root: function (_a) {
        var p = _a.props, v = _a.variables;
        return ({
            position: 'relative',
            marginTop: v.margin,
            marginBottom: v.margin,
        });
    },
    gutter: function (_a) {
        var p = _a.props, v = _a.variables;
        var _b;
        return (_b = {
                position: 'absolute',
                marginTop: v.gutterMargin
            },
            _b[p.gutterPosition === 'end' ? 'right' : 'left'] = 0,
            _b);
    },
    message: function (_a) {
        var p = _a.props, v = _a.variables;
        return ({
            position: 'relative',
            marginLeft: v.messageMargin,
            marginRight: v.messageMargin,
        });
    },
};
export default chatItemStyles;
